import { render } from "./MenuTrigger.vue?vue&type=template&id=125ac300&lang=pug"
import script from "./MenuTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuTrigger.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__